import { SenderResponseBody } from './types';

interface SendOptions {
  projectId: string;
  apiKey: string;
  endpointBase?: string;
}

export type SendTransport = 'fetch' | 'beacon';

function buildUrl(base: string | undefined, projectId: string): string {
  const origin = base || (typeof location !== 'undefined' ? location.origin : '');
  const slash = origin.endsWith('/') ? '' : '/';
  return `${origin}${slash}${projectId}/events`;
}

export async function sendBatchFetch(
  events: any[],
  opts: SendOptions,
  keepalive = false
): Promise<{ ok: boolean; status: number; body?: SenderResponseBody }> {
  const url = buildUrl(opts.endpointBase, opts.projectId);
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-ingest-key': opts.apiKey,
    },
    body: JSON.stringify({ events }),
    keepalive,
    credentials: 'omit',
    cache: 'no-store',
    mode: 'cors',
  });

  const status = res.status;
  let body: any = undefined;
  try { body = await res.json(); } catch { }
  return { ok: res.ok, status, body };
}

export function sendBatchBeacon(events: any[], opts: SendOptions): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return false;
  const url = buildUrl(opts.endpointBase, opts.projectId);
  try {
    const blob = new Blob([JSON.stringify({ events })], { type: 'application/json' });
    return navigator.sendBeacon(url, blob);
  } catch {
    return false;
  }
}

